import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';

import LoadingCenter from '../../../Components/LoadingCenter';
import DateRangeLabel from '../../../Components/DateRangeLabel';
import NumberColor from '../../../Components/NumberColor';
import BackButtonRouter from '../../../Components/BackButtonRouter';
import InputRow from '../../../Components/InputRow';
import StatusIcon from '../../../Components/StatusIcon';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';

import AppConfig from '../../../AppConfig';

import SearchFilterContext from '../../../Context/SearchFilterContext';

export default class IncentiveList extends Component {
	static contextType = SearchFilterContext;
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			filter: {
				name: '',
				startDate: null,
				endDate: null,
			},
			code: '',
			programs: [],
		};
	}

	async componentDidMount() {
		this.setState(
			{
				filter: {
					...this.context,
				},
			},
			async () => {
				await this.getPrograms();
			}
		);
	}

	getPrograms = async () => {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			this.context.updateSearchFilter(this.state.filter);
			this.setState({
				isLoading: true,
			});

			const startDate = this.state.filter.startDate.format('YYYY-MM-DD');
			const endDate = this.state.filter.endDate.format('YYYY-MM-DD');

			let filter = {
				startDate: startDate,
				endDate: endDate,
				searchBy: 'TravelingDate',
			};

			const { companyId } = this.props.match.params;
			if (companyId) {
				filter.incentiveCustomerId = companyId;
			}

			let requestPrograms = APIGet('incentive/programs', filter);

			requestPrograms = await requestPrograms;
			if (APIHelper.handleAPIResponse(this, requestPrograms)) {
				const programs = requestPrograms.data;
				console.log(programs);
				this.setState({
					isLoading: false,
					programs,
				});
			} else {
				toast.error('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
			}
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	};

	onFilterChange = (name, value) => {
		let filter = { ...this.state.filter };
		filter[name] = value;
		console.log(filter);
		this.setState({
			filter,
		});
	};

	handleInputChange = (key, value) => {
		this.setState({
			[key]: value,
		});
	};

	openByCode = async () => {
		let requestPrograms = await APIGet('incentive/programs?code=' + this.state.code);
		console.log(requestPrograms);
		if (APIHelper.handleAPIResponse(this, requestPrograms)) {
			const programs = requestPrograms.data;
			if (programs.length > 0) {
				const program = programs[0];
				this.props.history.push(AppConfig.appPath + '/programs/incentive/' + program.id);
			} else {
				toast.warning('ไม่พบโปรแกรมจาก code ที่คุณกรอก');
			}
		}
	};

	sumExpense = expenses => {
		let notPaidExpense = 0;
		let paidExpense = 0;
		let approvedAndPaidExpense = 0;
		expenses.forEach(e => {
			if (e.approvalStatus !== 'Not Approved') {
				if (e.isPaid && e.financeStaffId) {
					paidExpense += e.total * e.currencyRate;
				} else {
					notPaidExpense += e.total * e.currencyRate;
				}

				if (e.approvalStatus === 'Approved' && e.isPaid) {
					approvedAndPaidExpense += e.total * e.currencyRate;
				}
			}
		});
		return { notPaidExpense, paidExpense, approvedAndPaidExpense };
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		const { companyId } = this.props.match.params;

		let sumPositiveProfit = 0;
		let sumNegativeProfit = 0;
		let sumNotPaidExpense = 0;
		let sumPaidExpense = 0;
		let sumIncomeEtc = 0;
		let sumIncomeFromCustomer = 0;
		let sumToCollectFromCustomer = 0;
		let sumApprovedAndPaidExpense = 0;
		let sumProfit = 0;
		return (
			<div className="container">
				{!companyId ? (
					<BackButtonRouter link={AppConfig.appPath + '/'} title="ดูทั้งหมด" />
				) : (
					<BackButtonRouter link={`${AppConfig.appPath}/data/companies`} title="ลูกค้า" />
				)}
				<div className="columns">
					<div className="column is-4">
						<h2 className="title is-2">INCENTIVE</h2>
					</div>
					<div className="column is-2" />
					<div className="column is-2">
						<DatePicker
							selected={this.state.filter.startDate}
							onChange={newDate => this.onFilterChange('startDate', newDate)}
							dateFormat="DD MMM YYYY"
							className="input float-left"
						/>
					</div>
					<div className="column is-2">
						<DatePicker
							selected={this.state.filter.endDate}
							onChange={newDate => this.onFilterChange('endDate', newDate)}
							dateFormat="DD MMM YYYY"
							className="input float-left"
						/>
					</div>
					<div className="column is-2">
						<button className="button is-link" onClick={this.getPrograms}>
							ค้นหา
						</button>
					</div>
				</div>
				<div className="columns">
					<div className="column is-4">
						<InputRow
							placeholder="ดูจากรหัสโปรแกรม"
							keyProps="code"
							value={this.state.code}
							onInputChange={this.handleInputChange}
							disabled={false}
							isMandatory={false}
						/>
					</div>
					<div className="column is-2" style={{ paddingTop: 18 }}>
						<button className="button is-link" onClick={this.openByCode}>
							เปิด
						</button>
					</div>
					<div className="column is-6" style={{ textAlign: 'right' }}>
						<Link className="button is-success" to={AppConfig.appPath + '/programs/newincentive'}>
							เพิ่มรายการ
						</Link>
						<span> </span>
						<button className="button is-info">PDF</button>
					</div>
				</div>
				<div className="table-container">
					<table className="table is-hoverable is-fullwidth is-striped is-bordered">
						<thead>
							<tr className="table-header">
								<td width="3%">#</td>
								<td width="10%">วันเดินทาง</td>
								<td width="5%">สถานะ</td>
								<td width="20%">โปรแกรม (รหัสทัวร์)</td>
								<td width="10%">ยอดเรียกเก็บทั้งหมด</td>
								<td width="5%">รับชําระมาเเล้ว</td>
								<td width="5%">ค้างรับ</td>
								<td width="5%">ค้างจ่าย</td>
								<td width="5%">รายจ่ายหักลบเงินคืน</td>
								<td width="10%">กำไร</td>
								<td width="11%">เงินส่วนต่าง(+)</td>
								<td width="11%">เงินส่วนต่าง(-)</td>
							</tr>
						</thead>
						<tbody>
							{this.state.programs.map((program, index) => {
								const shouldShowProfit = program.status === 'In Progress';

								const { notPaidExpense, paidExpense, approvedAndPaidExpense } = this.sumExpense(program.incentiveExpenses);
								sumNotPaidExpense += notPaidExpense;
								sumPaidExpense += paidExpense;
								sumApprovedAndPaidExpense += approvedAndPaidExpense;

								const toCollectFromCustomer = program.incentiveIncomes.reduce((acc, income) => {
									return acc + income.toCollectFromCustomer * income.currencyRate;
								}, 0);

								const incomeFromCustomer = program.incentiveIncomes.reduce((acc, income) => {
									return acc + income.incomeFromCustomer * income.currencyRate;
								}, 0);

								const incomeEtc = program.incentiveIncomeEtcs.reduce((acc, income) => {
									return acc + income.total * income.currencyRate;
								}, 0);

								const profit = (incomeFromCustomer + incomeEtc) * program.currencyRate - approvedAndPaidExpense;
								if (shouldShowProfit) {
									if (profit > 0) {
										sumPositiveProfit += profit;
									} else {
										sumNegativeProfit += profit;
									}
								}

								sumProfit += profit;

								sumToCollectFromCustomer += toCollectFromCustomer;
								sumIncomeFromCustomer += incomeFromCustomer;
								sumIncomeEtc += incomeEtc;

								return (
									<tr key={program.id}>
										<td>{program.year_id_num}</td>
										<td>
											<DateRangeLabel startDate={program.startDate} endDate={program.endDate} />
										</td>
										<td style={{ textAlign: 'center' }}>
											<StatusIcon status={program.status} deletedAt={program.deleted_at} />{' '}
											<span style={{ color: 'red', fontSize: 10 }}>
												{program.deleted_by_user_name ? program.deleted_by_user_name : null}
											</span>
										</td>
										<td>
											<Link to={AppConfig.appPath + '/programs/incentive/' + program.id}>
												{program.title} <b>({program.code})</b>
											</Link>
										</td>
										<td className="number-cell">
											<NumberColor number={toCollectFromCustomer} />
										</td>
										<td className="number-cell">
											<NumberColor number={incomeFromCustomer} />
										</td>
										<td className="number-cell">
											<NumberColor number={toCollectFromCustomer - incomeFromCustomer} isExpense={true} />
										</td>
										<td className="number-cell">
											<NumberColor number={notPaidExpense} isExpense={true} />
										</td>
										<td className="number-cell">
											{/* incomeEtc คือเงินคืน */}
											<NumberColor number={paidExpense - incomeEtc} isExpense={true} />
										</td>
										<td className="number-cell">
											<NumberColor number={profit} />
										</td>
										<td className="number-cell">{shouldShowProfit ? <NumberColor number={profit > 0 ? profit : 0} /> : <>-</>}</td>
										<td className="number-cell">{shouldShowProfit ? <NumberColor number={profit <= 0 ? profit : 0} /> : <>-</>}</td>
									</tr>
								);
							})}
							<tr className="table-summary-row">
								<td colSpan="4" style={{ textAlign: 'center' }}>
									Summary
								</td>
								<td className="number-cell">
									<NumberColor number={sumToCollectFromCustomer} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumIncomeFromCustomer} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumToCollectFromCustomer - sumIncomeFromCustomer} isExpense={true} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumNotPaidExpense} isExpense={true} />
								</td>
								<td className="number-cell">
									{/* incomeEtc คือเงินคืน */}
									<NumberColor number={sumPaidExpense - sumIncomeEtc} isExpense={true} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumProfit} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumPositiveProfit} />
								</td>
								<td className="number-cell">
									<NumberColor number={sumNegativeProfit} />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<br />
			</div>
		);
	}
}
